// extracted by mini-css-extract-plugin
export var article = "BlogTemplate-module--article--9709d";
export var category = "BlogTemplate-module--category--fd2ea";
export var details = "BlogTemplate-module--details--8679b";
export var meta = "BlogTemplate-module--meta--282f9";
export var sidebar = "BlogTemplate-module--sidebar--03d11";
export var subscribe = "BlogTemplate-module--subscribe--0fba6";
export var thumbnail = "BlogTemplate-module--thumbnail--4bc35";
export var title = "BlogTemplate-module--title--2ebd9";
export var tools = "BlogTemplate-module--tools--8d384";
export var visibilitySensor = "BlogTemplate-module--visibilitySensor--90a26";
export var wrapper = "BlogTemplate-module--wrapper--7e2c0";
export var wrapperNoToc = "BlogTemplate-module--wrapperNoToc--28726";